//#region src/order_throttling_cap_duration.ts
var OrderThrottlingCapDuration = /* @__PURE__ */ function(OrderThrottlingCapDuration) {
	OrderThrottlingCapDuration["Current10"] = "current-10-minute-interval";
	OrderThrottlingCapDuration["Current15"] = "current-15-minute-interval";
	OrderThrottlingCapDuration["EntireTime"] = "entire-time-interval";
	return OrderThrottlingCapDuration;
}(OrderThrottlingCapDuration || {});
//#endregion
export { OrderThrottlingCapDuration };

//# sourceMappingURL=order_throttling_cap_duration.js.map